import { Reveal, Eyebrow } from "@/components/Reveal";

const About = ({ content }) => (
  <section id="about" className="relative py-24 sm:py-32 bg-paper overflow-x-clip" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-14 md:gap-20 items-center">
      <div>
        <Reveal>
          <Eyebrow>About Us</Eyebrow>
          <h2
            className="mt-5 font-display font-bold text-navy text-4xl sm:text-5xl leading-tight"
            data-testid="about-title"
          >
            {content.about_title}
          </h2>
          <span className="block mt-4 h-1.5 w-28 rounded-full bg-gradient-to-r from-verm via-marigold to-kite" />
        </Reveal>
        <Reveal delay={0.1}>
          <p
            className="mt-7 font-body text-navy/85 text-base sm:text-lg leading-relaxed"
            data-testid="about-text"
          >
            {content.about_text}
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <p
            className="mt-6 font-script text-3xl sm:text-4xl text-verm leading-snug"
            data-testid="about-punch"
          >
            {content.about_punch}
          </p>
          <p className="mt-4 font-display font-bold text-navy tracking-wide text-xl" data-testid="about-brand">
            WIND SKATERS — Fly Higher. Together.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.12} className="flex justify-center">
        <div className="relative w-[300px] h-[300px] sm:w-[420px] sm:h-[420px]" data-testid="about-medallion">
          <svg
            viewBox="0 0 100 100"
            className="absolute -inset-4 w-[calc(100%+2rem)] h-[calc(100%+2rem)] animate-spin-slow text-verm"
            aria-hidden="true"
          >
            <circle cx="50" cy="50" r="48.5" fill="none" stroke="currentColor" strokeWidth="1" strokeDasharray="4 3" />
          </svg>
          <div className="absolute inset-0 rounded-full border-[6px] border-verm ring-4 ring-marigold/60 shadow-2xl shadow-navy/25 overflow-hidden bg-paperdeep">
            <img
              src={content.about_image}
              alt="Folk art medallion — a child flying a kite at sunset"
              className="w-full h-full object-cover"
              data-testid="about-image"
            />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
